import { PageResponse } from '../../models/page-response';
import { MainComponent } from '../main/main.component';
import { TranslateService } from '@ngx-translate/core';
import { AdminUserService } from '../../services/admin-user-service';
import { AppConstant } from '../../constants/app.constant';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { AdminUser } from '../../models/admin-user';
import { Subject } from 'rxjs';
import { Component } from '@angular/core';
import { UserStatus, UserSearchingCriteria } from '../../models/user';
import { Role } from '../../models/role';
// import { RoleService } from '@services/role.service';
import { switchMap, debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { RoleService } from '@app/services/role.service';
import { ModulePathConstant } from '@app/constants/modulePath.constant';
import { MerchantAdminUserService } from '@app/services/merchant-user.service';
import { CommonResponse } from '@app/models/common-model';

@Component({
    templateUrl: './merchant-admin-user-list.component.html',
    styleUrls: ['./merchant-admin-user-list.component.scss']
})
export class MerchantAdminUserListComponent {

    statusOptions: UserStatus[] = ['ENABLED', 'DISABLED', 'LOCKED'];
    roleOptions: Role[] = [];

    private searchTermStream = new Subject<string>();

    loading: boolean = false;

    globalCriteria: string = '';
    searchingCriteria: UserSearchingCriteria = new UserSearchingCriteria();
    isAllowCreateNewUser: boolean = false;

    page: number = 1;
    size: number = 10;
    totalItems: number = 0;
    sortField: string;
    sortDirection: 'asc' | 'desc';

    pagingInfo: {
        start: number;
        end: number;
        total: number;
    }

    records: AdminUser[];

    constructor(private router: Router,
        private route: ActivatedRoute,
        public appConstant: AppConstant,
        private adminUserService: MerchantAdminUserService,
        private roleService: RoleService,
        private translate: TranslateService,
        private mainComponent: MainComponent) {
    }

    ngOnInit(): void {

        this.loading = true;
        this.pagingInfo = {
            start: 0,
            end: 0,
            total: 0
        }

        this.route.params
            .pipe(
                switchMap(async (params: Params) => {
                    this.loading = true;
                    this.records = [];

                    this.globalCriteria = params['global'] || '';
                    this.page = Number(params['page']) || 1;
                    this.sortField = params['sortField'] || 'username';
                    this.sortDirection = params['sortDirection'] || 'asc';

                    if (params['searchingCriteria'] != null) {
                        this.searchingCriteria = JSON.parse(params['searchingCriteria']);
                    } else {
                        this.searchingCriteria = new UserSearchingCriteria();
                    }
                    return params;
                }),
                switchMap((params: Params) => {
                    return this.adminUserService.checkAllowNewUserCreate()
                        .pipe(
                            map((resp:CommonResponse) => {
                                this.isAllowCreateNewUser = resp.content.status=='TRUE';
                                return params;
                            })
                        );
                }),
                switchMap(async (params: Params) => {

                    let roles = await this.roleService.getRoleByType('ADMIN').toPromise();
                    this.roleOptions = roles;

                    return this.adminUserService.globalSearch(this.globalCriteria, this.searchingCriteria, this.page - 1, this.size, this.sortField, this.sortDirection).toPromise();
                })
            )
            .subscribe((res: PageResponse<AdminUser>) => {
                this.loading = false;
                this.page = res.number + 1;
                this.totalItems = res.totalElements;
                this.records = res.content;
                this.pagingInfo.start = (this.page - 1) * this.size + 1;
                this.pagingInfo.end = this.page * this.size;
                this.pagingInfo.total = this.totalItems;
                if (this.pagingInfo.end > this.pagingInfo.total) {
                    this.pagingInfo.end = this.pagingInfo.total;
                }
            });

        this.searchTermStream
            .pipe(debounceTime(500), distinctUntilChanged())
            .subscribe((term: string) => this.doSearch(this.globalCriteria, this.page, this.sortField, this.sortDirection));

    }

    sort(field: string): void {
        this.sortField = field;

        if (this.sortField === field) {
            this.sortDirection === 'asc' ? this.sortDirection = 'desc' : this.sortDirection = 'asc';
        } else {
            this.sortField = field;
            this.sortDirection === 'asc';
        }

        this.doSearch(this.globalCriteria, this.page, field, this.sortDirection);
    }

    ngOnDestroy(): void {
    }

    pageChange(changedPage: number): void {
        if (this.page != changedPage) {
            this.doSearch(this.globalCriteria, changedPage, this.sortField, this.sortDirection);
        }
    };

    search(term: string) {
        this.searchTermStream.next(term);
    }

    submitSearch(): void {
        this.doSearch(this.globalCriteria, this.page, this.sortField, this.sortDirection);
    }

    private doSearch(criteria: string, page: number, sortField: string, sortDirection: string) {

        this.router.navigate([ModulePathConstant.USER_PATH, {
            global: criteria,
            page: page,
            sortField: sortField,
            sortDirection: sortDirection,
            searchingCriteria: JSON.stringify(this.searchingCriteria)
        }]);
    }

}